<div style="display: flex; align-items: center; justify-content: space-between;">
    <div><h4 *ngIf="!IsSystemImages" _ngcontent-mpo-c365="">Component Images - {{sideName}} {{name}} {{PositionName}}</h4>
    <h4 *ngIf="IsSystemImages" _ngcontent-mpo-c365="">System Images -{{sideName}} {{name}} {{PositionName}}</h4>
    </div>

<div style="text-align: right;">
    <i class="material-icons __close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
</div>


<div *ngIf="groupedList.length>0;else NoData" style=" display: flex; gap: 5px;flex-direction: column;">
  <div *ngFor="let group of groupedList" >
<div class="image-container">
    <div class="image-header">
       
        <div class="div-flex">
          <span class="image-text-label">Date: </span>
          <span class="comment-label">{{group.inspectionDate |date: 'dd MMM yyyy'}}</span>
        </div>
      
        <div class="div-flex">
            <span class="image-text-label">SMU: </span>
            <span class="comment-label">{{group.smu}}</span>
        </div>
      
        <div class="div-flex" *ngIf="!IsSystemImages">
            <span class="image-text-label">Worn%:</span>
            <span class="comment-label">{{group.wornpercentage}}%</span>
        </div>
         <div *ngIf="!IsSystemImages">
          <span class="image-text-label">Comments: </span>
          <span class="comment-text">{{group.Comment}}</span>
      </div>
   <div>
  
   
</div>
    </div>
 <img style="width:180px" class="inspection-observation-photo"  *ngFor="let img of group.images" [src]="img"  (click)="openImagePopUp(img)"/>
</div>
  <!-- <div class="image-wrapper">
    <img *ngFor="let img of group.images" [src]="img" alt="Inspection Image" width="150" style="object-fit: contain;" (click)="OpenImage(img)" />
  </div> -->
</div>
</div>

<ng-template #NoData>
  <div class="text-center">
<h3> No data found!</h3>

  </div>
</ng-template>